import { ga, message, adType } from '../config';
import AdFactory from '../lib/ad/AdFactory';
import Base from './Base';
import LocalStorage from '../model/LocalStorage';

const gaCategory = {
    click: ga.category.click.gameResult,
};

/**
 * 結果表示
 */
export default class Result extends Base {
    /**
     * constructor
     */
    constructor() {
        super({
            el: '.js-game-result ',
            freeEl: '.js-game-result__free',
            textEl: '.js-game-result__text',
            scoreWrapperEl: '.js-game-result__score-wrapper',
            scoreEl: '.js-game-result__latest-score',
            highscoreEl: '.js-game-result__highscore',
            retryButtonEl: '.js-retry__button',
            AdEl: '.js-game-result__ad',
        });
    }

    /**
     * initialize
     */
    initialize() {
        /** @property {Number} retrycnt リトライ数 */
        this.retrycnt = 0;

        /** @property {Number} reloadcnt リトライ広告を表示するリトライ数 */
        this.reloadcnt = this.config.reloadcnt;

        /** @property {class} admodule 広告モジュール */
        this.admodule = AdFactory.getInstance(
            this.config.adparam.result,
            adType.result,
            { target: this.$AdEl },
        );

        /** @property {LocalStorage} localStorage ローカルストレージclass */
        this.localStorage = new LocalStorage(this.config);

        this.binds();
    }

    /**
     * イベントリスナー登録
     */
    binds() {
        this.$retryButtonEl
            .addEventListener('click', e => this.onRetryClick(e));
    }

    /**
     * リトライボタンクリック時
     */
    onRetryClick() {
        this.hide();

        this.retrycnt += 1;
        const isShowAd = this.retrycnt % this.reloadcnt === 0;

        this.observer.emit(message.resultClickRetry, isShowAd);
    }

    /**
     * 表示する
     *
     * @param {object} payload ペイロード { score: string; text: string; stage: string }
     */
    show(payload) {
        const { score = '0', text = '', stage = '1', free = '' } = payload;

        const key = `highscore_${stage}`;
        const highscore = this.localStorage.get(key) || 0;

        if (free) {
            this.$scoreWrapperEl.style.display = 'none';
            this.$freeEl.innerHTML = free;
            this.$freeEl.style.display = 'block';
        } else {
            if (text) {
                // 結果テキスト表示
                this.$textEl.innerText = text;
                this.$textEl.style.display = 'block';
                this.$scoreWrapperEl.classList.add('-hastext');
            }

            if (Number(score) > Number(highscore)) {
                this.$scoreWrapperEl.classList.add('-record');
                this.localStorage.set(key, score);
            }

            // スコア表示
            this.$scoreEl.innerText = score;
            this.$highscoreEl.innerText = highscore;
        }

        // 広告
        this.admodule.load();

        this.$el.style.display = 'block';
    }

    /**
     * 非表示にする
     */
    hide() {
        this.reset();
    }

    /**
     * 初期状態に戻す
     */
    reset() {
        this.$el.style.display = '';
        this.$scoreWrapperEl.style.display = '';
        this.$scoreWrapperEl.classList.remove('-record', '-hastext');
        this.$textEl.innerText = '';
        this.$textEl.style.display = '';
        this.$freeEl.style.display = '';
        this.$freeEl.innerHTML = '';
        this.admodule.remove();
    }
}
